<kendo-dialog
  *ngIf="isVisible()"
  [title]="'Configuration Status Details'"
  (close)="onCancelChanges()"
  [width]="'95vw'"
  [height]="'90vh'"
  [minWidth]="'800px'"
  [maxWidth]="'1400px'"
>
  <div class="config-details-content">
    <!-- Loading State -->
    <div
      *ngIf="isLoading()"
      class="loading-container"
    >
      <kendo-loader
        [type]="'infinite-spinner'"
        [size]="'large'"
      ></kendo-loader>
      <p class="mt-3">Loading configuration details...</p>
    </div>

    <!-- Content -->
    <div
      *ngIf="!isLoading() && configurationData()"
      class="config-content"
    >
      <!-- Summary Statistics -->
      <div class="summary-stats mb-4">
        <div class="row">
          <div class="col-md-3">
            <div class="stat-card stat-compliant">
              <div class="stat-number">{{ complianceStats().compliant }}</div>
              <div class="stat-label">Compliant</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card stat-accepted">
              <div class="stat-number">{{ complianceStats().acceptedDeviations }}</div>
              <div class="stat-label">Accepted Deviations</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card stat-non-compliant">
              <div class="stat-number">{{ complianceStats().nonCompliant }}</div>
              <div class="stat-label">Non-Compliant</div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="stat-card stat-overall">
              <div class="stat-number">{{ complianceStats().compliancePercentage }}%</div>
              <div class="stat-label">Overall Compliance</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Configuration Items List -->
      <div class="config-items-container">
        <div class="config-items-header">
          <h5>Configuration Items</h5>
          <small class="text-muted">Manage your organization's email security configuration settings</small>
        </div>

        <div class="config-items-list">
          @for (item of configurationItems(); track item.id) {
            <div
              class="config-item-card"
              [ngClass]="{
                'has-changes': localChanges().has(item.id)
              }"
            >
              <div class="config-item-header">
                <div class="config-item-info">
                  <div class="config-item-name">
                    <span class="status-icon">{{ getStatusIcon(item) }}</span>
                    {{ item.name }}
                    <span
                      *ngIf="item.isPolicySpecific"
                      class="badge badge-info ms-2"
                      title="Policy Specific"
                    >
                      Policy
                    </span>
                  </div>
                  <div class="config-item-standard">
                    <strong>Gold Standard:</strong>
                    {{ item.goldStandardSetting }}
                  </div>
                </div>
                <div class="config-item-status">
                  <span
                    class="status-badge"
                    [ngClass]="getStatusClass(item)"
                  >
                    {{ getStatusText(item) }}
                  </span>
                </div>
              </div>

              <!-- Deviation Management (only if deviation can be accepted) -->
              <div
                *ngIf="item.canAcceptDeviation && item.currentStatus === 'non_compliant'"
                class="deviation-controls"
              >
                <div class="deviation-switch">
                  <label class="form-label">
                    <kendo-switch
                      [checked]="item.isDeviationAccepted"
                      (valueChange)="updateDeviation(item.id, $event)"
                    ></kendo-switch>
                    <span class="ms-2">Accept deviation from gold standard</span>
                  </label>
                </div>

                <!-- Exception Note (only if deviation is accepted) -->
                <div
                  *ngIf="item.isDeviationAccepted"
                  class="exception-note mt-3"
                >
                  <label class="form-label">Exception Note</label>
                  <textarea
                    class="form-control"
                    [value]="item.exceptionNote || ''"
                    (input)="updateNote(item.id, $any($event.target).value)"
                    placeholder="Explain why this deviation is acceptable for your organization..."
                    rows="3"
                  ></textarea>
                </div>
              </div>

              <!-- Read-only deviation info for items that can't accept deviations -->
              <div
                *ngIf="!item.canAcceptDeviation && item.currentStatus === 'non_compliant'"
                class="deviation-info"
              >
                <div class="alert alert-warning mb-0">
                  <i class="fa fa-exclamation-triangle me-2"></i>
                  This configuration item requires compliance and cannot accept deviations.
                </div>
              </div>

              <!-- Show existing exception note for compliant items that previously had accepted deviations -->
              <div
                *ngIf="item.currentStatus === 'compliant' && item.exceptionNote"
                class="existing-note"
              >
                <small class="text-muted">
                  <strong>Previous Exception Note:</strong>
                  {{ item.exceptionNote }}
                </small>
              </div>

              <div class="config-item-footer">
                <small class="text-muted">Last updated: {{ item.lastUpdated | date: 'short' }}</small>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div
      *ngIf="!isLoading() && !configurationData()"
      class="error-container"
    >
      <div class="alert alert-danger">
        <i class="fa fa-exclamation-circle me-2"></i>
        Failed to load configuration details. Please try again.
      </div>
    </div>
  </div>

  <kendo-dialog-actions>
    <button
      kendoButton
      (click)="onCancelChanges()"
      [disabled]="isLoading()"
    >
      {{ hasUnsavedChanges() ? 'Cancel Changes' : 'Close' }}
    </button>
    <button
      *ngIf="hasUnsavedChanges()"
      kendoButton
      [themeColor]="'primary'"
      (click)="onSaveChanges()"
      [disabled]="isLoading()"
    >
      Save Changes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
